export default __webpack_public_path__ + "static/media/Apple iPhone 11 Pro Max.13175d66.png";